export default __webpack_public_path__ + "static/media/entipi.75c56bcb.JPG";